import { DigitalEmployeeHandler } from "./digital-employee.handler.js";

function init() {
  // Find our script tag to read data attributes
  const scripts = document.querySelectorAll("script[data-slug]");
  const scriptTag = scripts[scripts.length - 1];

  // Read config from script tag or URL path (/meet/:slug)
  let slug = "demo";
  let type = "floating";

  if (scriptTag) {
    slug = scriptTag.getAttribute("data-slug") || slug;
    type = scriptTag.getAttribute("data-type") || type;

    // Read API base URL from script tag
    const apiUrl = scriptTag.getAttribute("data-api-url");
    if (apiUrl) {
      window.__DIGITAL_EMPLOYEE_API_URL__ = apiUrl;
    }
  }

  // Support standalone /meet/:slug route
  const pathMatch = window.location.pathname.match(/^\/meet\/([^/]+)/);
  if (pathMatch) {
    slug = pathMatch[1];
  }

  // Parse topic key from URL query param
  const urlParams = new URLSearchParams(window.location.search);
  const topicKey = urlParams.get("topic") || null;

  // Create container
  const container = document.createElement("div");
  container.id = "digital-employee-widget";
  if (type === "inline") {
    container.classList.add("sm-widget-inline");
  }

  if (type === "inline" && scriptTag?.parentElement) {
    // Insert inline widget where the script tag is
    scriptTag.parentElement.insertBefore(container, scriptTag);
  } else {
    // Floating: append to body
    document.body.appendChild(container);
  }

  DigitalEmployeeHandler.init(slug, type, topicKey);
}

// Run immediately if DOM is ready, otherwise wait
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
